export enum EMediaType {
    IMAGE = 'image', // imagem
    VIDEO = 'video', // video
    RAW = 'raw', // documentos
    AUDIO = 'audio', // audio
}

// É permitido arquivos nos formatos: [image, video, documento, audio]

export enum EMediaProvider {
    AWS = 1,
    CLOUDINARY = 2,
}

export enum EMediaModule {
    ORDER = 1,
    FINANCIAL = 2,
    EMPLOYEE = 3,
    SUPPLIER = 4,
    CUSTOMER = 5,
    LABORATORY = 6,
    PRODUCT = 7,
    SERVICE = 8,
    AVATAR = 9,
    NOTIFICATION = 10,
    NF = 11,
    NF_REGISTRATION = 12,

    KIWID_PAY_BANK_SLIP = 999,
    KIWID_PAY_SETTINGS = 1000,
    KIWID_FEATURE_MEDIA = 1001,
}
